import * as ko from "knockout";
import {IMessageData} from "../../../../../../index";
import {KOSubscriptionTracker} from "../../../../../../util/KOSubscriptionTracker";
import {ObjectTypeId} from "../../../../../../constants";
import {IMutableSyncfieldParameters} from "../../index";
import {global} from "../../../../../../appContext";
import {ErrorTracker} from "../../../../../../error.tracker";
import {DynamicProperties} from "../../DynamicProperties";

export interface IAbstractParams {
    dynamicProperties: DynamicProperties
    parameter: IMutableSyncfieldParameters
}

export abstract class AbstractParameter {

    protected readonly ObjectTypeId = ObjectTypeId;
    protected readonly isReady: KnockoutObservable<boolean> = ko.observable(false);
    protected readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    protected readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected readonly parameter: IMutableSyncfieldParameters;
    protected readonly et: ErrorTracker = global.errorAreas.get('dynamic.properties');

    constructor(protected params: IAbstractParams) {
        this.parameter = params.parameter;
    }

    protected getPlaceholder() {
        return this.parameter.parameter || this.parameter.displayname || this.parameter.name;
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
